import { render, staticRenderFns } from "./ProcessInformationObligation.vue?vue&type=template&id=b754bb20&scoped=true&"
import script from "./ProcessInformationObligation.vue?vue&type=script&lang=js&"
export * from "./ProcessInformationObligation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b754bb20",
  null
  
)

export default component.exports